import {InitForm} from "./classes/init.js";

import CitrusIblockElement from "./components/form.vue";

const install = function (Vue) {
	Vue.component("CitrusIblockElement", CitrusIblockElement);
};

const VueCitrusIblockElement = {CitrusIblockElement, install};

export {InitForm, VueCitrusIblockElement};
